/**
 * @hidden
 */
export var FOCUSABLE_ELEMENTS = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]'
];
/**
 * @hidden
 */
var Navigation = /** @class */ (function () {
    function Navigation(options) {
        var _this = this;
        this.rovingTabIndex = true;
        this.update = function () { };
        this.focusNextIndex = function (target, indexDiff) {
            var all = _this.elements;
            var index = all.indexOf(target) + indexDiff;
            index = index < 0 ? all.length - 1 : index;
            _this.focusElement(all[index % all.length], target);
        };
        this.tabIndex = options.tabIndex || 0;
        this.root = options.root;
        this.selectors = options.selectors;
        this.rovingTabIndex = options.rovingTabIndex !== undefined ? options.rovingTabIndex : true;
        this.mouseEvents = options.mouseEvents || {};
        this.keyboardEvents = options.keyboardEvents || {};
    }
    Object.defineProperty(Navigation.prototype, "elements", {
        get: function () {
            return this.root.current ? Array.from(this.root.current.querySelectorAll(this.selectors.join(','))) : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Navigation.prototype, "first", {
        get: function () {
            return (this.root.current && this.root.current.querySelector(this.selectors.join(','))) || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Navigation.prototype, "last", {
        get: function () {
            var all = this.elements;
            return all[all.length - 1] || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Navigation.prototype, "current", {
        get: function () {
            return this.elements.find(function (el) { return el.matches(':focus'); }) || null;
        },
        enumerable: false,
        configurable: true
    });
    Navigation.prototype.focusNext = function (target) {
        this.focusNextIndex(target, 1);
    };
    Navigation.prototype.focusPrevious = function (target) {
        this.focusNextIndex(target, -1);
    };
    Navigation.prototype.triggerKeyboardEvent = function (ev) {
        var target = ev.target instanceof Element && ev.target.closest(this.selectors.join(','));
        var key = ev.key === ' ' ? 'Space' : ev.key;
        var eventType = ev.nativeEvent.type;
        if (target && this.keyboardEvents[eventType][key]) {
            this.keyboardEvents[eventType][key].call(undefined, target, this, ev);
        }
    };
    Navigation.prototype.triggerMouseEvent = function (ev) {
        var target = ev.target instanceof Element && ev.target.closest(this.selectors.join(','));
        var eventType = ev.nativeEvent.type;
        if (target) {
            this.mouseEvents[eventType].call(undefined, target, this, ev);
        }
    };
    Navigation.prototype.focusElement = function (element, previous) {
        if (element) {
            if (previous) {
                if (this.rovingTabIndex) {
                    previous.removeAttribute('tabindex');
                }
                previous.classList.remove('k-focus');
            }
            if (this.rovingTabIndex) {
                element.setAttribute('tabindex', String(this.tabIndex));
            }
            element.focus({ preventScroll: true });
        }
    };
    return Navigation;
}());
export { Navigation };
;
